module.exports = __webpack_public_path__ + "img/start.d0b3f474.svg";